<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户分组</span>
          <el-button v-permisaction="['config:userGroup:add']" type="primary" size="mini" style="margin-left: 16px;" @click="edit(0)">新增</el-button>
        </div>

        <template>
          <el-table
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="groupId"
              label="分组ID"
              width="150px"
              align="center"
            />
            <el-table-column
              prop="name"
              label="分组名称"
              align="center"
            />
            <el-table-column
              prop="remark"
              label="备注"
              align="center"
            />
            <el-table-column
              fixed="right"
              label="操作"
              width="100"
            >
              <template v-slot:default="scope">
                <el-button v-permisaction="['config:userGroup:edit']" type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total>0"
            background
            :page.sync="queryParams.pageIndex"
            :limit.sync="queryParams.pageSize"
            :total="total"
            @pagination="getTables"
          />
        </template>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserTypeList } from '@/api/config/user-group-cfg'

export default {
  name: 'UserGroup',
  data() {
    return {
      total: 0,
      tableData: [],
      loading: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleClose(d) {
      this.drawer = false
    },
    edit(id) {
      this.$router.push({ name: 'UserGroupEdit', query: { id: id }})
    },
    getTables() {
      this.loading = true
      getUserTypeList(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    statusFormatter(row, col) {
      let statusText = ''
      for (const i in this.statusType) {
        const val = this.statusType[i]
        if (val.value === row.status) {
          statusText = val.label
          break
        }
      }
      return statusText
    },
    userTypeFormatter(row, col) {
      let userTypeText = ''
      for (const i in this.userType) {
        const val = this.userType[i]
        if (val.value === row.status) {
          userTypeText = val.label
          break
        }
      }
      return userTypeText
    },
    randomRewardFormatter(row, col) {
      let randomRewardText = ''
      for (const i in this.rewardType) {
        const val = this.rewardType[i]
        if (val.value === row.status) {
          randomRewardText = val.label
          break
        }
      }
      return randomRewardText
    }
  }
}
</script>

<style scoped>
</style>
